import { useEffect, useRef, useState } from "react";

const originalTitle = process.env.REACT_APP_NAMA_RUMAH_SAKIT || document.title;

const tick = (notification) => {
    document.title = document.title === notification ? originalTitle : notification;
}

export default function useTabNotification ({interval = 1000}) {
    const [notification, setNotification] = useState(null);
    const intervalRef = useRef(null);

    const clearNotification = () => {
        document.title = originalTitle
        setNotification(null);
    };

    const resetTimer = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    }

    useEffect(() => {
        (!intervalRef.current && notification) ? intervalRef.current = setInterval(tick, interval, notification) : resetTimer()
    }, [notification]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect (() => () => clearInterval(intervalRef?.current), []);

    return [setNotification, clearNotification];
}